export default __webpack_public_path__ + "static/media/Pending3.84637308.svg";